import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import StoryCard from '../components/storyComponents/StoryCard';
import SharedStoryCard from '../components/sharedStory/SharedStoryCard';
import HomeStories from '../components/storyComponents/HomeStories';
import SharedStoryBtn from '../components/SharedStoryBtn';
import { loadSharedStory, loadHomeStories, loadSharedStories } from '../actions';
import SocialShareButtons from '../components/SocialShareButtons';
import { push, replace } from 'react-router-redux';
import { asyncActions } from 'react-async-actions';
import Image from '../components/Image';
import { filter } from 'lodash/collection';


const splitCopyIntoParagraphs = (content) => {
  content = content.split(/\n\s*\n/g).map(line => `<p>${line}</p>`).join('');

  return content
}

const YouTubeVideo = (id, width, height) => (
    <div className="youtube-wrapper">
        <div className="youtube">
            <iframe style={{border:0}} width={`${width}`} height={`${height}`}
                className="youtube-frame"
                src={`https://www.youtube.com/embed/${id}?autoplay=0`}
                allowFullScreen
            />
        </div>
    </div>

);

const actionsToFire = (props) => [
  props.loadHomeStories(),
  props.loadSharedStory(props.params.id)
]

@asyncActions(actionsToFire)
class SharedStoryDetail extends Component {
  state = {
    bannerWidth: '',
    bannerHeight: ''
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.props.loadSharedStory(nextProps.params.id)
    }
  }
  componentWillMount() {
    this.props.loadHomeStories();
    this.props.loadSharedStories();
    this.props.loadSharedStory(this.props.router.params.id);

    let bannerWidth = '';
    let bannerHeight = '';
    if (this.props.browser.greaterThan.desktop) {
      bannerWidth = 640;
      bannerHeight = 360;
    } else { // We are in mobile
      bannerWidth = this.props.browser.width;
      bannerHeight = Math.round(bannerWidth / 1.777);
    }

    this.setState({bannerWidth: bannerWidth, bannerHeight: bannerHeight})
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.props.loadSharedStory(this.props.router.params.id);
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  mergeStories = (homeStories, sharedStories) => {
    // Merge home stories with shared stories into allStories
    var allStories = homeStories.concat(sharedStories);
    return allStories;
  }

  sortStories = (allStories) => {
    // Sort homeStories by js_date which pulls from status_changed in backend
        allStories.sort(function(a, b){
          var dateA = a.js_date, dateB = b.js_date;
          if (dateA > dateB) {
            return -1;
          }
          if (dateA < dateB) {
            return 1;
          }
          return 0;
        });

        return allStories;
  }

  render() {

    let isLoaded = this.props.sharedStoryDetail.isLoaded;
    if (!isLoaded) {
      return <span />;
    }

    let homeStoriesLoaded = this.props.homeStories.isLoaded;
    if (!homeStoriesLoaded) {
      return <span />;
    }

    let sharedStoriesLoaded = this.props.sharedStories.isLoaded;
    if (!sharedStoriesLoaded) {
      return <span />;
    }

    let sharedStoryDetail = this.props.sharedStoryDetail;
    let storyDetailId = this.props.sharedStoryDetail.id;
    let bylinePrefix = 'by ' + this.props.sharedStoryDetail.full_name;
    let bannerImg = this.props.sharedStoryDetail.www_photo;
    let bannerImgSized = `thumbnails/?model=sharedstory&id=${sharedStoryDetail.id}&size=638x425&source=www_photo`;
    let storyTitle = this.props.sharedStoryDetail.title;
    let storyId = this.props.sharedStoryDetail.id;



    let firstName = this.props.sharedStoryDetail.first_name;
    let title = this.props.sharedStoryDetail.title;
    let experiences = this.props.sharedStoryDetail.experiences;
    let imagine = this.props.sharedStoryDetail.imagine;
    let thumbnailCopy = this.props.sharedStoryDetail.thumbnailCopy;
    let influences = this.props.sharedStoryDetail.influences;
    let userBackground = this.props.sharedStoryDetail.user_background;
    let likeWebsite = this.props.sharedStoryDetail.like_website;
    let fbLink = this.props.sharedStoryDetail.share_facebook;
    let linkedinLink = this.props.sharedStoryDetail.share_linkedin;

    let fbWrapper = '';
    let linkedinWrapper = '';

    if (fbLink != null && linkedinLink != null) {
      fbWrapper = <div className="sharedStoryDetail-fbWrapper">Connect with {firstName} through <a href={fbLink} target="_blank">Facebook</a> and <a href={linkedinLink} target="_blank">Linkedin</a>.</div>
    } else if (fbLink != null && linkedinLink == null) {
      fbWrapper = <div className="sharedStoryDetail-fbWrapper">Connect with {firstName} through <a href={fbLink} target="_blank">Facebook</a>.</div>
    } else if (linkedinLink != null && fbLink == null) {
      fbWrapper = <div className="sharedStoryDetail-fbWrapper">Connect with {firstName} through <a href={linkedinLink} target="_blank">Linkedin</a>.</div>
    }

    if (fbLink != null) {

    }


    let isExternalAsset = this.props.sharedStoryDetail.is_external_asset;
    let externalAssetName = this.props.sharedStoryDetail.external_asset_name;

    let bannerUrl = '';
    bannerUrl = this.props.sharedStoryDetail.www_photo;
    let orgLogo = '';
    let orgDetailPageId = '';
    orgDetailPageId = this.props.sharedStoryDetail.organization;

    let orgDetailPageUrl = '';
    if (orgDetailPageId != '') {
      orgDetailPageUrl = '/organizations/' + orgDetailPageId;
    }



    let storyCopy = '';
    let author = '';
    let thumbnailText = '';
    thumbnailText = this.props.sharedStoryDetail.thumbnailCopy;
    let authorObj = '';
    let path = this.props.router.location.pathname;
    let youtubeVideoId = this.props.sharedStoryDetail.youtubeVideoId;
    let facebookVideoId = this.props.sharedStoryDetail.facebookVideoId;
    let banner = '';
    let bannerWidth = '';
    let bannerHeight = '';

    bannerWidth = this.state.bannerWidth;
    bannerHeight = this.state.bannerHeight;

    // Test if there is a youtube, fb video or a simple image
    // If bannerUrl is not empty then wrap the banner image in
    // a link to an external site.
    if (youtubeVideoId != null && youtubeVideoId != '') {
      banner = YouTubeVideo(youtubeVideoId, bannerWidth, bannerHeight);
    } else if (bannerImg != null && bannerUrl != '') {
      banner = <img src={bannerImg} />
    } else if (bannerImg != null) {
      banner = <img src={bannerImg} />
    }



    let allStories = this.mergeStories(this.props.homeStories, this.props.sharedStories);

    let sortedStories = this.sortStories(allStories);

    sortedStories = filter(sortedStories, function(obj) {
      return obj.id !== sharedStoryDetail.id;
    })


    let storyList = '';

    storyList = sortedStories.map((story, index) => {

      if (index <= 5) {
        if (story.story_type == 'shared_story') { // filter by shared_story but not the featured story
          return <div className="homeStories-storyCardWrapper">
                      <SharedStoryCard
                        key={story.id}
                        sharedstory={story}
                        browser={this.props.browser}
                      />
                    </div>;
        } else if (story.story_type == 'news') {
          return <div className="homeStories-storyCardWrapper">
                      <StoryCard
                        key={story.id}
                        story={story}
                        browser={this.props.browser}
                      />
                    </div>;
        }
      }


    });


    function createMarkup(content) {
      var splitCopy = splitCopyIntoParagraphs(content);
      return { __html: splitCopyIntoParagraphs(content).split('\n').join('<br/>') };
    }

/*
    storyCopy = createMarkup(content);
    storyCopy = <div className="story-copy" dangerouslySetInnerHTML={createMarkup(content)}></div>;
*/
    let meta = {
      title: `WorldWideWomen | ${storyTitle}`,
      description: `${thumbnailText}`,
      canonical: `https://worldwidewomen.co/story/${storyId}`,
      meta: {
        property: {
          'og:type': 'article',
          'og:image': `${bannerImg}`,
          'og:title': `WorldWideWomen | ${storyTitle}`,
          'og:description': `${thumbnailText}`,
          'og:site_name': 'WorldWideWomen',
          'og:url': `https://worldwidewomen.co/story/${storyId}`
        }
      },
      auto: {
        ograph: true,
      },
    }

    return(
      <main>
        <div>
        <DocumentMeta {...meta} />
          <div className="content-wrapper">
            <div className="storyDetail-wrapper">
              <div className="storyDetail-bannerWrapper">
                <div className="storyDetail-banner">
                  <Image className="" src={bannerImgSized} />
                </div>

                <div className="storyDetail-titleWrapperOuter">
                  <div className="storyDetail-titleWrapper">
                    <h4>{storyTitle}</h4>
                    <div className="storyDetail-byline">
                      {bylinePrefix}
                    </div>

                    <div className="storyDetail-socialShareBtnWrapper">
                      <SocialShareButtons
                        storyTitle={storyTitle}
                        path={path}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="storyDetail-copyWrapper">
                <div className="storyDetail-questionAnswer">
                  <span className="boldText">Q: Tell us a bit about yourself and your career path so far.</span><br/ >
                  A: {userBackground}
                </div>

                <div className="storyDetail-sharedStorySeparator">
                  ***
                </div>

                <div className="storyDetail-questionAnswer">
                  <span className="boldText">Q: Who is the greatest female influence in your life?</span><br/ >
                  A: {influences}
                </div>

                <div className="storyDetail-sharedStorySeparator">
                  ***
                </div>

                <div className="storyDetail-questionAnswer">
                  <span className="boldText">Q: share with us something that you want other women around the world to hear.</span><br/ >
                  A: {experiences}
                </div>

                <div className="storyDetail-sharedStorySeparator">
                  ***
                </div>

                <div className="storyDetail-questionAnswer">
                  <span className="boldText">Q: What do you imagine for women and girls around the world?</span><br/ >
                  A: {imagine}
                </div>

                <div className="storyDetail-sharedStorySeparator">
                  ***
                </div>

                <div className="storyDetail-questionAnswer">
                  <span className="boldText">Q: What do you like most about the WorldWideWomen website?</span><br/ >
                  A: {likeWebsite}
                </div>

                <div className="storyDetail-questionAnswer">
                  {fbWrapper}
                </div>



              </div>
            </div>

            <div className="sharedStoryBtn-wrapper">
              <SharedStoryBtn />
            </div>

          </div>




          <div className="storyDetail-storyCardWrapperOuter">
            <div className="content-wrapper">
              <div className="storyDetail-storyCardHeader">
                YOU MIGHT ALSO LIKE...
              </div>
              <div className="storyDetail-storyCardsInnerWrapper">
                {storyList}
              </div>
            </div>
          </div>


        </div>
      </main>
    )
  }
}



function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    loadSharedStory,
    loadHomeStories,
    loadSharedStories,
    push
  }
)(SharedStoryDetail);



// WEBPACK FOOTER //
// ./src/containers/SharedStoryDetail.jsx